import * as Yup from 'yup';

const isAdult = new Date();
isAdult.setFullYear(isAdult.getFullYear() - 18);

const validationSchema = (t) => {
  return Yup.object({
    dateOfBirth: Yup.date()
      .min(new Date(1900, 0, 1), 'biometric.birthDate.validation.min')
      .max(isAdult, 'biometric.birthDate.validation.adult')
      .required('The field is required'),
    heightValue: Yup.number()
      .min(101, t('biometric.height.validation', { min: '101 cm', max: '249 cm' }))
      .max(249, t('biometric.height.validation', { min: '101 cm', max: '249 cm' }))
      .when('heightUnit', {
        is: (value) => value && value === 'in',
        then: (schema) =>
          schema
            .min(40, t('biometric.height.validation', { min: '3 ft 4 in', max: '8 ft 2 in' }))
            .max(98, t('biometric.height.validation', { min: '3 ft 4 in', max: '8 ft 2 in' })),
      }),
  });
};

export default validationSchema;
